import { Component, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ContactCardDto, TVPackageAgent_assocDto } from '@hub/generated/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

const noop = () => { };

export const CUSTOM_MULTIPIC_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => FormMultipickerComponent),
  multi: true
};

@Component({
  selector: 'fm-multi-picker',
  templateUrl: 'form-multi-picker.component.html',
  styles: [
    `
    `
  ],
	providers: [CUSTOM_MULTIPIC_CONTROL_VALUE_ACCESSOR]
})
export class FormMultipickerComponent
  implements ControlValueAccessor, OnInit, OnDestroy {
  constructor() {}

  contacts: TVPackageAgent_assocDto[];
  isNotObject: boolean;
  @Input() suggestions: ContactCardDto[];
  
  tabindex: string;
  @Input('tabindex')
  set tabin(val: string) {
    this.tabindex = String(val);
  }

  @Input() searchMethod: (s: string) => Observable<ContactCardDto[]>;
  @Input() isEditable: boolean;
  
  private innerValue: any = '';

  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;
  
  ngOnInit() {
  }

  ngOnDestroy() {
  }
  onDragChange(event) {
    this.setItemsOrderValue();
    this.onChangeCallback(this.contacts);
  }

  private setItemsOrderValue() {
    let i = 1;
    this.contacts.forEach((c: TVPackageAgent_assocDto) => {
      c.Order = i;
      i++;
    });
  }

  search(event: any) {
    this.searchMethod(event.query)
      .pipe(
        map(c => c.filter(x => !this.contacts.some(f => f.ConnectId === x.ConnectId)))
      )
      .subscribe(contacts => { this.suggestions = contacts });
  }
  
  get value(): any {
    return this.innerValue;
  }

  set value(v: any) {
    if (v !== this.innerValue) {
      if (v && v.Id && !this.contacts.some(x => x.ConnectId === v.ConnectId)) {
        this.contacts.push(v);
        this.setItemsOrderValue();
        this.innerValue = null;        
        this.onChangeCallback(this.contacts);
      }
    }
  }

  // Set touched on blur
  onBlur(event) {
    this.onTouchedCallback();
  }

  onFocus(event: Event) {
    this.onTouchedCallback();
  }

  writeValue(value: any) {
    this.contacts = !value ? [] : value;
  }

  // From ControlValueAccessor interface
  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  // From ControlValueAccessor interface
  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  remove(contact: ContactCardDto) {
    this.contacts = this.contacts.filter(x => x.ConnectId !== contact.ConnectId);
    this.onChangeCallback(this.contacts);
  }
}
